import { createFileRoute } from "@tanstack/react-router";
import { MacroCatalog } from "@/components/views/macro/MacroCatalog";
import { currentUserId } from "@/data";

export const Route = createFileRoute("/my-macros")({
  component: MyMacrosRoute,
});

function MyMacrosRoute() {
  return (
    <MacroCatalog
      scope={(m) => m.authorId === currentUserId || (m.coAuthorIds ?? []).includes(currentUserId)}
    />
  );
}
